import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Routes,
} from '@angular/router';
import { AdminNavigationTemplateComponent } from '@context/frontend/navigation';
import {
	AuthGuard,
	CustomSuperAuthGuard,
	redirectUnauthorizedTo,
	SplashGuard,
} from '@context/frontend/user';

export const appRoutes: Routes = [
	{
		path: 'auth',
		canActivate: [SplashGuard],
		loadChildren: () => import('./pages/auth/auth.routes'),
	},
	{
		path: '',
		component: AdminNavigationTemplateComponent,
		canActivate: [AuthGuard, CustomSuperAuthGuard],
		data: {
			authGuardPipe: (
				_r: ActivatedRouteSnapshot,
				{ url }: RouterStateSnapshot,
			) =>
				redirectUnauthorizedTo(
					`auth?redirectUrl=${encodeURIComponent(url)}`,
				),
		},
		children: [
			{
				path: 'organizations',
				loadChildren: () =>
					import('./pages/organizations/organizations.routes'),
			},
			{
				redirectTo: 'organizations',
				path: '**',
			},
		],
	},
	{
		redirectTo: 'organizations',
		path: '**',
	},
];
